<div class="container-admin">
  <mat-card>
    <mat-card-content>
      <mat-tab-group>
        <!--<mat-tab label="testing">
    <simple-grid #testObject LoadingText="Loading Test Data..."></simple-grid>
  </mat-tab>-->

        <mat-tab label="Interactives">
          <mat-tab-group>
            <mat-tab label="Interactive List">
              <ng-container *ngIf="loadingInteractiveData">
                <i class="fas fa-spinner fa-pulse"></i>Loading Interactives,
                Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addInteractive()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedInteractive()">
                      Edit Selected
                    </button>
                    <!--<button mat-button
                      class="piButton"
                      (click)="editSelectedInteractivePreFilter()">
                Edit Select Pre-Filter Options
              </button>-->
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsInteractive()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allInteractives"
                                     [columnDefs]="interactiveColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Interactive Reports">
              <ng-container *ngIf="loadingInteractiveReportData">
                <i class="fas fa-spinner fa-pulse"></i>Loading Interactive
                Reports, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addInteractiveReport()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedInteractiveReport()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="deleteSelectedInteractiveReport()">
                      Delete Selected
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsInteractiveReport()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveReportDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allInteractiveReports"
                                     [columnDefs]="interactiveReportColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Interactive Subscriptions">
              <ng-container *ngIf="loadingInteractiveSubscriptionData">
                <i class="fas fa-spinner fa-pulse"></i>Loading Interactive
                Subscriptions, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addInteractiveSubscription()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedInteractiveSubscription()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="copySelectedInteractiveSubscriptionPurchaseUrl()">
                      Copy Selected Purchase URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsInteractiveSubscription()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveSubscriptionDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allInteractiveSubscriptions"
                                     [columnDefs]="interactiveSubscriptionColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Interactive Subscriptions Levels">
              <ng-container *ngIf="loadingInteractiveSubscriptionLevels">
                <i class="fas fa-spinner fa-pulse"></i>Loading Interactive
                Subscription Levels, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addInteractiveSubscriptionLevel()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedInteractiveSubscriptionLevel()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="
                        copySelectedInteractiveSubscriptionLevelPurchaseUrl()
                      ">
                      Copy Selected Purchase URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsInteractiveSubscriptionLevel()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveSubscriptionLevelDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allInteractiveSubscriptionLevels"
                                     [columnDefs]="interactiveSubscriptionLevelColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Interactive Subscriptions Prices">
              <ng-container *ngIf="loadingInteractiveSubscriptionPrices">
                <i class="fas fa-spinner fa-pulse"></i>Loading Interactive
                Subscription Prices, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addInteractiveSubscriptionPrice()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedInteractiveSubscriptionPrice()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="copySelectedInteractiveSubscriptionPricePurchaseUrl()">
                      Copy Selected Purchase URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsInteractiveSubscriptionPrice()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveSubscriptionPriceDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allInteractiveSubscriptionPrices"
                                     [columnDefs]="interactiveSubscriptionPriceColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Subscription Period Types">
              <ng-container *ngIf="loadingPeriodTypes">
                <i class="fas fa-spinner fa-pulse"></i>Loading Period Types,
                Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsSubscriptionPeriodType()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #subscriptionPeriodTypeDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allPeriodTypes"
                                     [columnDefs]="subscriptionPeriodTypeColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="Analytical Datasets">
          <mat-tab-group>
            <mat-tab label="Analytical Dataset Subscriptions">
              <ng-container *ngIf="loadingXmlaSubscriptionData">
                <i class="fas fa-spinner fa-pulse"></i>Loading Analytical Datasets
                Subscriptions, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addXmlaSubscription()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedXmlaSubscription()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="copySelectedXmlaSubscriptionPurchaseUrl()">
                      Copy Selected Purchase URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsXmlaSubscription()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #xmlaSubscriptionDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allXmlaSubscriptions"
                                     [columnDefs]="xmlaSubscriptionColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Analytical Dataset Subscriptions Levels">
              <ng-container *ngIf="loadingXmlaSubscriptionLevels">
                <i class="fas fa-spinner fa-pulse"></i>Loading Analytical Dataset Subscription
                Levels, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addXmlaSubscriptionLevel()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedXmlaSubscriptionLevel()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="deleteSelectedXmlaSubscriptionLevel()">
                      Delete Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="copySelectedXmlaSubscriptionLevelPurchaseUrl()">
                      Copy Selected Purchase URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsXmlaSubscriptionLevel()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #xmlaSubscriptionLevelDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allXmlaSubscriptionLevels"
                                     [columnDefs]="xmlaSubscriptionLevelColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Analytical Dataset Subscriptions Prices">
              <ng-container *ngIf="loadingXmlaSubscriptionPrices">
                <i class="fas fa-spinner fa-pulse"></i>Loading Analytical Dataset Subscription
                Prices, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addXmlaSubscriptionPrice()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedXmlaSubscriptionPrice()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="deleteSelectedXmlaSubscriptionPrice()">
                      Delete Selected
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsXmlaSubscriptionPrice()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #xmlaSubscriptionPriceDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allXmlaSubscriptionPrices"
                                     [columnDefs]="xmlaSubscriptionPriceColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="Subscriptions">
          <mat-tab-group>
            <mat-tab label="Subscriptions List">
              <ng-container *ngIf="loadingSubscriptions">
                <i class="fas fa-spinner fa-pulse"></i>Loading Subscriptions,
                Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedSubscription()">
                      Edit Selected
                    </button>
                    <!-- <button mat-button class="piButton" (click)="deleteSelectedSubscription()">Delete Selected</button>
              <button mat-button class="piButton" (click)="cancelSelectedSubscription()">Cancel Selected Subscription</button>-->
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsSubscription()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #subscriptionDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allSubscriptions"
                                     [columnDefs]="subscriptionColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Process Subscription Order Payment">
              <ng-container *ngIf="loadingUnpaidOrders">
                <i class="fas fa-spinner fa-pulse"></i>Loading Unpaid Orders,
                Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="processSelectedOrderPayment()">
                      Process Selected Payment
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsUnpaidOrder()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #unpaidOrderDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allUnpaidOrders"
                                     [columnDefs]="unpaidOrderColumnDefs"
                                     rowSelection="single"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     (columnResized)="onUnpaidOrderColumnResized($event)"
                                     (columnVisible)="onUnpaidOrderColumnVisible($event)"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Modified Interactive List">
              <ng-container *ngIf="loadingModifiedInteractives">
                <i class="fas fa-spinner fa-pulse"></i>Loading Modified
                Interactives, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button class="piButton" (click)="deleteModifiedInteractive()">Delete Selected Interactive</button>
                    <button mat-button class="piButton" (click)="permanentDeleteModifiedInteractive()">Permanent Delete Selected Interactive</button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsModifiedInteractives()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #modifiedinteractiveDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allModifiedInteractives"
                                     [columnDefs]="modifiedinteractiveColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Subscription / User List">
              <ng-container *ngIf="loadingSubscriptionUsers">
                <i class="fas fa-spinner fa-pulse"></i>Loading Subscription
                Users, Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsSubscriptionUser()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #subscriptionuserDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allSubscriptionUsers"
                                     [columnDefs]="subscriptionuserColumnDefs"
                                     rowSelection="single"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     (columnResized)="onSubscriptionUsersColumnResized($event)"
                                     (columnVisible)="onSubscriptionUsersColumnVisible($event)"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>

            <mat-tab label="Coupon Codes">
              <ng-container *ngIf="loadingCoupons">
                <i class="fas fa-spinner fa-pulse"></i>Loading Coupon Code,
                Please Wait...
              </ng-container>

              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addCouponCode()">
                      Create New
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedCouponCode()">
                      Edit Selected
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedCouponLevels()">
                      Edit Selected Levels
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsCouponCode()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #couponcodeDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allCoupons"
                                     [columnDefs]="couponcodeColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="Users">
          <ng-container *ngIf="loadingUsers">
            <i class="fas fa-spinner fa-pulse"></i>Loading Users, Please Wait...
          </ng-container>

          <ng-container>
            <div class="admin-grid-container">
              <div class="admin-grid-actions-container">
                <button mat-button
                        class="piButton"
                        (click)="editSelectedUser()">
                  Edit Selected
                </button>
                <div></div>
                <button mat-button
                        class="piButton"
                        (click)="resizeColumnsUser()">
                  Auto Size Columns
                </button>
              </div>
              <div class="admin-grid">
                <ag-grid-angular #userDataGrid
                                 style="width: 100%; height: 100%"
                                 class="ag-theme-alpine"
                                 [rowData]="allUsers"
                                 [columnDefs]="userColumnDefs"
                                 (firstDataRendered)="onFirstDataRendered($event)"
                                 rowSelection="single"></ag-grid-angular>
              </div>
            </div>
          </ng-container>
        </mat-tab>

        <mat-tab label="Subscription Management">
          <mat-card style="height: unset;">
            <mat-card-title>
              Subscriptions - Search By Subscription, Organization, Name or Email Address
            </mat-card-title>
            <mat-card-content style="height: unset;">
              <mat-form-field style="width:100%">
                <mat-select [formControl]="subscriptionSearchCtrl" placeholder="Search Subscriptions">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="subscriptionSearchFilterCtrl"
                                           placeholderLabel="Search Subscriptions"></ngx-mat-select-search>
                  </mat-option>

                  <mat-option *ngFor="let subscription of filteredSubscriptions | async" [value]="subscription">
                    {{ subscription.subscriptionName }} [{{ subscription.organizationName }}]
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-card-content>
          </mat-card>
          <mat-tab-group *ngIf="currentlySelectedSubscription">
            <mat-tab label="Subscription Details / Actions">
              <mat-card style="height: unset;" *ngIf="currentlySelectedSubscription">
                <mat-card-content style="height: unset;">
                  <div>
                    <button mat-button class="piButton" (click)="editSelectedDetailsSubscription()">Edit Subscription</button>
                    <button mat-button class="piButton" (click)="cancelSelectedDetailsSubscription()">Cancel Subscription</button>
                    <button mat-button class="piButton" (click)="deleteSelectedDetailsSubscription()">Permanently Delete Subscription</button>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card style="height: unset;" *ngIf="currentlySelectedSubscription">
                <mat-card-content style="height: unset;">
                  <table border="1" style="width: 100%;">
                    <tr>
                      <th>Subscription</th>
                      <td>{{ currentlySelectedSubscription.subscriptionName }}</td>
                      <th></th>
                      <td></td>
                    </tr>
                    <tr>
                      <th>Level</th>
                      <td>{{ currentlySelectedSubscription.subscriptionLevelName }}</td>
                      <th>Period</th>
                      <td>{{ currentlySelectedSubscription.periodTypeName }}</td>
                    </tr>
                    <tr>
                      <th>Organization</th>
                      <td>{{ currentlySelectedSubscription.organizationName }}</td>
                      <th>Organization Address</th>
                      <td>
                        {{ currentlySelectedSubscription.addressLine1 }}<br />
                        {{ currentlySelectedSubscription.addressLine2 }}<br />
                        {{ currentlySelectedSubscription.city }}, {{ currentlySelectedSubscription.state }} {{ currentlySelectedSubscription.zip }}
                      </td>
                    </tr>
                    <tr>
                      <th>Created</th>
                      <td>{{ currentlySelectedSubscription.createdDate | date : 'longDate' }}</td>
                      <th>Expires</th>
                      <td>{{ currentlySelectedSubscription.expireDate | date : 'longDate' }}</td>
                    </tr>
                    <tr>
                      <th>Purchaser</th>
                      <td>{{ currentlySelectedSubscription.purchaserFirstName }} {{ currentlySelectedSubscription.purchaserLastName }}</td>
                      <th>Purchaser Title</th>
                      <td>{{ currentlySelectedSubscription.purchaserTitle }}</td>
                    </tr>
                    <tr>
                      <th>Purchaser Email</th>
                      <td>{{ currentlySelectedSubscription.purchaserEmail }}</td>
                      <th>Purchaser Phone</th>
                      <td>{{ currentlySelectedSubscription.purchaserPhone }}</td>
                    </tr>
                    <tr>
                      <th>Auto Renew?</th>
                      <td>{{ currentlySelectedSubscription.autoRenew }}</td>
                      <th>Max Admin Users</th>
                      <td>{{ currentlySelectedSubscription.maxAdminUsers }}</td>
                    </tr>
                    <tr>
                      <th>Max Design Users</th>
                      <td>{{ currentlySelectedSubscription.maxDesignerUsers }}</td>
                      <th>Max Dashboard Users</th>
                      <td>{{ currentlySelectedSubscription.maxDashboardUsers }}</td>
                    </tr>
                    <tr>
                      <th>Max Report Users</th>
                      <td>{{ currentlySelectedSubscription.maxReportUsers }}</td>
                      <th></th>
                      <td></td>
                    </tr>
                    <tr>
                      <th>API Key</th>
                      <td>{{currentlySelectedSubscription.apiSubscriptionToken}}</td>
                      <th></th>
                      <td></td>
                    </tr>
                  </table>
                </mat-card-content>
              </mat-card>
            </mat-tab>
            <mat-tab label="Users">
              <mat-card style="height: unset;" *ngIf="currentlySelectedSubscription">
                <mat-card-content style="height: unset;">
                  <div class="admin-grid-container" style="height: 400px; overflow-y: scroll;">
                    <div class="admin-grid-actions-container">
                      <button mat-button
                              class="piButton"
                              (click)="addUser()">
                        Add User
                      </button>
                      <button mat-button
                              class="piButton"
                              (click)="editSelectedDetailsUser()">
                        Edit Selected
                      </button>
                      <button mat-button
                              class="piButton"
                              (click)="deleteSelectedDetailsUser()">
                        Delete Selected
                      </button>
                      <div></div>
                      <button mat-button
                              class="piButton"
                              (click)="resizeColumnsSubscriptionUsersDetails()">
                        Auto Size Columns
                      </button>
                    </div>
                    <div class="admin-grid">
                      <ag-grid-angular *ngIf="(filteredSubscriptionUsers | async).length > 0"
                                       #subscriptionUsersDataGrid
                                       style="width: 100%;"
                                       class="ag-theme-alpine"
                                       [rowData]="filteredSubscriptionUsers | async"
                                       [columnDefs]="subscriptionUsersColumnDefs"
                                       rowSelection="single"
                                       (firstDataRendered)="onFirstDataRendered($event)"
                                       (columnResized)="onSubscriptionUsersColumnResized(this)"
                                       (columnVisible)="onSubscriptionUsersColumnVisible($event)"></ag-grid-angular>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-tab>
            <mat-tab label="UnRegistered Users (Invitations)">
              <mat-card style="height: unset;" *ngIf="currentlySelectedSubscription">
                <mat-card-content style="height: unset;">
                  <div class="admin-grid-container" style="height: 400px; overflow-y: scroll;">
                    <div class="admin-grid-actions-container">
                      <button mat-button
                              class="piButton"
                              (click)="resendInvitationEmail()">
                        Re-Send Invitation Email
                      </button>
                      <button mat-button
                              class="piButton"
                              (click)="deleteInvitation()">
                        Delete Invitation
                      </button>
                      <div></div>
                      <button mat-button
                              class="piButton"
                              (click)="resizeColumnsSubscriptionUnRegisteredUsersDetails()">
                        Auto Size Columns
                      </button>
                    </div>
                    <div class="admin-grid">
                      <ag-grid-angular #subscriptionUnRegisteredUsersDataGrid
                                       style="width: 100%;"
                                       class="ag-theme-alpine"
                                       [rowData]="filteredSubscriptionUnRegisteredUsers | async"
                                       [columnDefs]="subscriptionUnRegisteredUsersColumnDefs"
                                       rowSelection="single"
                                       (firstDataRendered)="onFirstDataRendered($event)"
                                       (columnResized)="onSubscriptionUnRegisteredUsersColumnResized(this)"
                                       (columnVisible)="onSubscriptionUnRegisteredUsersColumnVisible($event)"></ag-grid-angular>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-tab>
            <mat-tab label="Interactives">
              <mat-tab-group>
                <mat-tab label="Standard Interactives">
                  <mat-card style="height: unset" *ngIf="currentlySelectedSubscription">
                    <mat-card-content style="height: unset;">
                      <div class="admin-grid-container" style="height: 400px; overflow-y: scroll;">
                        <div class="admin-grid-actions-container">
                          <mat-select [(ngModel)]="selectedAsUser" style="width: 300px">
                            <mat-option [value]="undefined"></mat-option>
                            <mat-option *ngFor="let user of filteredSubscriptionUsers | async" [value]="user">
                              {{user.firstName
                        }} {{user.lastName}}
                        </mat-option>
                        </mat-select>
                        <button mat-button class="piButton" (click)="loadInteractiveAsSelectedUser()">Load Interactive As Selected User</button>
                        <div></div>
                        <button mat-button
                                class="piButton"
                                (click)="resizeColumnsSubscriptionDetailsInteractives()">
                          Auto Size Columns
                        </button>
</div>
                        <div class="admin-grid">
                          <ag-grid-angular #subscriptionInteractsDataGrid
                                           style="width: 100%; height: 100%"
                                           class="ag-theme-alpine"
                                           [rowData]="filteredInteractives | async"
                                           [columnDefs]="subscriptionInteractiveColumnDefs"
                                           (firstDataRendered)="onFirstDataRendered($event)"
                                           rowSelection="single"></ag-grid-angular>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Modified Interactives">
                  <mat-card style="height: unset;" *ngIf="currentlySelectedSubscription">
                    <mat-card-content style="height: unset;">
                      <div class="admin-grid-container" style="height: 400px; overflow-y: scroll;">
                        <div class="admin-grid-actions-container">
                          <mat-select [(ngModel)]="selectedAsUser" style="width: 300px">
                            <mat-option [value]="undefined"></mat-option>
                            <mat-option *ngFor="let user of filteredSubscriptionUsers | async" [value]="user">
                              {{user.firstName}} {{user.lastName}}
                            </mat-option>
                          </mat-select>
                          <button mat-button class="piButton" (click)="editInteractiveAsSelectedUser()">Edit Interactive As Selected User</button>
                          <button mat-button class="piButton" (click)="deleteSubscriptionModifiedInteractive()">Delete Selected Interactive</button>
                          <button mat-button class="piButton" (click)="permanentDeleteSubscriptionModifiedInteractive()">Permanent Delete Selected Interactive</button>
                          <div></div>
                          <button mat-button
                                  class="piButton"
                                  (click)="resizeColumnsSubscriptionDetailsInteractives()">
                            Auto Size Columns
                          </button>
                        </div>
                        <div class="admin-grid">
                          <ag-grid-angular #subscriptionModifedInteractivesDataGrid
                                           style="width: 100%; height: 100%"
                                           class="ag-theme-alpine"
                                           [rowData]="filteredSubscriptionInteractives | async"
                                           [columnDefs]="subscriptionInteractivesDataGridColumnDefs"
                                           (firstDataRendered)="onFirstDataRendered($event)"
                                           rowSelection="single"></ag-grid-angular>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </mat-tab>
              </mat-tab-group>
            </mat-tab>
            <mat-tab label="Pre Filters">
              <pre-filter-editor [subscriptionId]="currentlySelectedSubscription?.subscriptionId"></pre-filter-editor>
            </mat-tab>
            <mat-tab label="Subscription Statistics">
              <mat-tab-group *ngIf="baseSubscriptionStats">
                <mat-tab label="Base Stats">
                  <mat-card style="height: unset;">
                    <mat-card-content style="height: unset;">
                      <table border="1" style="width: 100%;">
                        <tr>
                          <th>Last Login User</th>
                          <td>{{baseSubscriptionStats.latestSubscriptionLogin.userName}} ({{baseSubscriptionStats.latestSubscriptionLogin.email}})</td>
                        </tr>
                        <tr>
                          <th>Last Login Time</th>
                          <td>{{baseSubscriptionStats.latestSubscriptionLogin.lastLogin | date : 'medium'}}</td>
                        </tr>
                      </table>
                    </mat-card-content>
                  </mat-card>
                </mat-tab>
                <mat-tab label="Interactive Stats">
                  <div class="admin-grid">
                    <ag-grid-angular #interactiveStatsDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="interactiveStats"
                                     [columnDefs]="interactiveStatDetailsColumnDef"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </mat-tab>
                <mat-tab label="User Stats">
                  <div class="admin-grid">
                    <ag-grid-angular #subscriptionStatsUserDataGrid
                                     style="width: 100%; height: 40%"
                                     class="ag-theme-alpine"
                                     [rowData]="baseSubscriptionStats.users"
                                     [columnDefs]="subscriptionStatsUserDataGridColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"
                                     (selectionChanged)="userAnalyticsRowSelected($event)"></ag-grid-angular>
                  </div>
                  <div style="width: 100%">
                    <div class="admin-grid">
                      <ag-grid-angular #userInteractiveStatsDataGrid
                                       style="width: 100%; height: 40%"
                                       class="ag-theme-alpine"
                                       [rowData]="userInteractiveStats"
                                       [columnDefs]="interactiveStatDetailsColumnDef"
                                       (firstDataRendered)="onFirstDataRendered($event)"
                                       rowSelection="single"
                                       (selectionChanged)="interactiveAnalyticsRowSelected($event)"></ag-grid-angular>
                    </div>
                    <mat-tab-group>
                      <mat-tab label="Bookmarks">
                        <div class="admin-grid">
                          <ag-grid-angular #interactiveBookmarkStatsDataGrid
                                           style="width: 100%; height: 40%"
                                           class="ag-theme-alpine"
                                           [rowData]="interactiveBookmarkStats"
                                           [columnDefs]="usageAnalyticsColumnDef"
                                           (firstDataRendered)="onFirstDataRendered($event)"
                                           rowSelection="single"></ag-grid-angular>
                        </div>
                      </mat-tab>
                      <mat-tab label="Filters">
                        <div class="admin-grid">
                          <ag-grid-angular #interactiveFilterStatsDataGrid
                                           style="width: 100%; height: 40%"
                                           class="ag-theme-alpine"
                                           [rowData]="interactiveFilterStats"
                                           [columnDefs]="usageAnalyticsColumnDef"
                                           (firstDataRendered)="onFirstDataRendered($event)"
                                           rowSelection="single"></ag-grid-angular>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="Partners">
          <mat-tab-group>
            <mat-tab label="Embeds">
              <ng-container *ngIf="loadingPartnerEmbeds">
                <i class="fas fa-spinner fa-pulse"></i>Loading Partner Embeds,
                Please Wait...
              </ng-container>
              <ng-container>
                <div class="admin-grid-container">
                  <div class="admin-grid-actions-container">
                    <button mat-button
                            class="piButton"
                            (click)="addPartnerEmbed()">
                      Add Partner Embed
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="editSelectedPartnerEmbed()">
                      Edit Selected Partner Embed
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="deleteSelectedPartnerEmbed()">
                      Delete Selected Partner Embed
                    </button>
                    <button mat-button
                            class="piButton"
                            (click)="copyPartnerEmbedUrl()">
                      Copy Partner Embed URL
                    </button>
                    <div></div>
                    <button mat-button
                            class="piButton"
                            (click)="resizeColumnsPartnerEmbed()">
                      Auto Size Columns
                    </button>
                  </div>
                  <div class="admin-grid">
                    <ag-grid-angular #partnerEmbedDataGrid
                                     style="width: 100%; height: 100%"
                                     class="ag-theme-alpine"
                                     [rowData]="allPartnerEmbeds"
                                     [columnDefs]="partnerEmbedColumnDefs"
                                     (firstDataRendered)="onFirstDataRendered($event)"
                                     rowSelection="single"></ag-grid-angular>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab label="Alerts">
          <mat-card style="height: unset;">
            <mat-card-title>
              Create New Alert
            </mat-card-title>
            <mat-card-content style="height: unset;">
              <table border="1" style="width: 100%">
                <tr>
                  <th style="width: 10%">Active?</th>
                  <th>Message</th>
                  <td style="width: 10%"></td>
                </tr>
                <tr>
                  <td><input type="checkbox" [(ngModel)]="newAlertMessage.active" /></td>
                  <td><textarea style="width: 100%" [(ngModel)]="newAlertMessage.message"></textarea></td>
                  <td><button (click)="createNewAlert()">Create</button></td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>
          <mat-card style="height: unset;">
            <mat-card-title>
              Current Alerts
            </mat-card-title>
            <mat-card-content style="height: unset;">
              <table border="1" style="width: 100%">
                <tr>
                  <th style="width: 10%">Active?</th>
                  <th>Message</th>
                  <td style="width: 10%"></td>
                  <td style="width: 10%"></td>
                </tr>
                <tr *ngFor="let msg of alertMessages">
                  <td><input type="checkbox" [(ngModel)]="msg.active" /></td>
                  <td><textarea style="width: 100%" [(ngModel)]="msg.message"></textarea></td>
                  <td><button (click)="saveAlertChanges(msg)">Save</button></td>
                  <td><button (click)="deleteAlert(msg)">Delete</button></td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>
        </mat-tab>
        <mat-tab label="Global Settings">
          <mat-card style="height: unset;">
            <mat-card-title>
              Global Settings
            </mat-card-title>
            <mat-card-content style="height: unset;">
              <table>
                <thead>
                  <tr>
                    <th>Setting</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><a [href]="tosUrl" target="_blank">Terms and Conditions</a></td>
                    <td><input type="file" id="tosInputFile" (change)="handleTosFileChange($event.target.files)" /></td>
                  </tr>
                  <tr>
                    <td><a [href]="ppUrl" target="_blank">Privacy Policy</a></td>
                    <td><input type="file" id="ppInputFile" (change)="handlePpFileChange($event.target.files)" /></td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>

<div [hidden]="!showPowerBi" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1000; background-color: #106bae">
  <app-powerbi-embed (closeClicked)="closeInteractiveClicked()"></app-powerbi-embed>
</div>
